import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { ActiveExport } from 'records/Export';
import { exportAllData } from '../services/exportService';

export interface ExportActions {
  addActiveExport: (
    actionParams: AppStateActionParams,
    activeExport: ActiveExport
  ) => AppState;
  removeActiveExport: (
    actionParams: AppStateActionParams,
    id: string
  ) => AppState;
  clearActiveExports: (actionParams: AppStateActionParams) => AppState;
  exportAllData: (
    actionParams: AppStateActionParams,
    filesToExport: {
      drawings: boolean;
      punch: boolean;
      rfis: boolean;
      submittals: boolean;
      users: boolean;
    }
  ) => Promise<AppState>;
}

const exportActions: ExportActions = {
  addActiveExport: (
    { state }: AppStateActionParams,
    activeExport: ActiveExport
  ): AppState => {
    return state().setIn(['activeExports', activeExport.fileid], activeExport);
  },
  removeActiveExport: (
    { state }: AppStateActionParams,
    id: string
  ): AppState => {
    return state().removeIn(['activeExports', id]);
  },
  clearActiveExports: ({ state }: AppStateActionParams): AppState => {
    return state().set(
      'activeExports',
      Immutable.OrderedMap<string, ActiveExport>()
    );
  },
  exportAllData: async (
    { state }: AppStateActionParams,
    filesToExport: {
      drawings: boolean;
      punch: boolean;
      rfis: boolean;
      submittals: boolean;
      users: boolean;
    }
  ): Promise<AppState> => {
    const projectId = state().getProject().id;

    await exportAllData(
      projectId,
      filesToExport.drawings,
      filesToExport.punch,
      filesToExport.rfis,
      filesToExport.submittals,
      filesToExport.users
    );

    return state();
  },
};

export default exportActions;
